import useSWR from "swr";

import { ArtRow } from "../components/KbCards";
import { Icon } from "../components/Icon";
import { api, type KbArticleListItem } from "../services/api";

/** Articles the user has bookmarked. */
export function KbSaved() {
  const { data } = useSWR<KbArticleListItem[]>("/api/kb/saved", () => api.kb.saved());
  const items = data ?? [];
  return (
    <div className="kb-page">
      <div className="page-header">
        <h1 className="page-title">Saved</h1>
        <p className="page-subtitle">Articles you&apos;ve bookmarked for later.</p>
      </div>
      {items.length > 0 ? (
        <div className="kb-art-list">
          {items.map((a) => (
            <ArtRow key={a.id} article={a} />
          ))}
        </div>
      ) : (
        <div className="kb-empty">
          <div className="kb-empty-ico">
            <Icon name="bookmark" size={26} />
          </div>
          <h3>Nothing saved yet</h3>
          <p>
            Tap the bookmark on any article to keep it here for quick access &mdash; handy for guides
            you refer back to, like MFA setup.
          </p>
        </div>
      )}
    </div>
  );
}

export default KbSaved;
